import { initAjaxLoadMore } from './ajax-load-more';

export const EVENTS_LOAD_MORE_WRAP_SELECTOR =
  '[data-events-load-more-wrap], [data-news-load-more-wrap]';
export const EVENTS_LOAD_MORE_BTN_SELECTOR = '[data-events-load-more], [data-news-load-more]';

export function initEventsCalendarLoadMore(root?: ParentNode): void {
  const scope = root ?? document;

  initAjaxLoadMore(scope, {
    gridSelector: '[data-events-grid]',
    wrapSelector: EVENTS_LOAD_MORE_WRAP_SELECTOR,
    btnSelector: EVENTS_LOAD_MORE_BTN_SELECTOR,
    cardSelector: 'a.events-calendar-item',
    initFlag: 'eventsLoadMoreBound',
  });
}
